import { AutogenModelPayeeDrsPayeeQuicklayout, AutogenRowPayeeDrsPayeeQuicklayout } from "./autogen/AutogenModelPayeeDrsPayeeQuicklayout";

export class ModelPayeeDrsPayeeQuicklayout extends AutogenModelPayeeDrsPayeeQuicklayout<RowPayeeDrsPayeeQuicklayout> {
	constructor() {
		super(RowPayeeDrsPayeeQuicklayout);
	}
}

export class RowPayeeDrsPayeeQuicklayout extends AutogenRowPayeeDrsPayeeQuicklayout {
}